<template src="./template.html"></template>

<script>
  export default {
    name: 'ModuleTitle',
    props: {
      moduleClass: String,
      title: String,
    },
  }
</script>
